export class MPAPoliciesInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<ActionApprovalRule>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAPoliciesInfo.attributeTypeMap;
    }
    constructor() {
    }
}
